import React from "react";
import {
  Typography,
  Select,
  MenuItem,
  makeStyles,
  Paper,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  toolbar: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(1),
    padding: theme.spacing(1),
    backgroundColor: theme.palette.background.paper,
    borderBottom: "none",
    marginBottom: 0,
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(0.75),
      gap: theme.spacing(0.5),
    },
  },
  container: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      justifyContent: "center",
    },
  },
  templateSelector: {
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "stretch",
      width: "100%",
      maxWidth: "300px",
    },
  },
  templateLabel: {
    marginRight: 16,
    [theme.breakpoints.down("sm")]: {
      marginRight: 0,
      marginBottom: theme.spacing(0.5),
      fontSize: "0.9rem",
      fontWeight: "bold",
    },
  },
  select: {
    minWidth: 150,
    [theme.breakpoints.down("sm")]: {
      minWidth: "100%",
      "& .MuiSelect-select": {
        paddingTop: theme.spacing(0.75),
        paddingBottom: theme.spacing(0.75),
      },
    },
  },
}));

/**
 * TemplateSelector Component
 *
 * A component for selecting resume templates
 *
 * @param {Object} props - Component props
 * @param {string} props.selectedTemplate - The currently selected template
 * @param {Function} props.onTemplateChange - Callback for when the template changes
 * @param {Array} props.templates - Available templates
 * @returns {JSX.Element} The rendered component
 */
const TemplateSelector = ({
  selectedTemplate,
  onTemplateChange,
  templates,
}) => {
  const classes = useStyles();

  return (
    <Paper className={classes.toolbar} elevation={1} square>
      <div className={classes.container}>
        <div className={classes.templateSelector}>
          <Typography variant="body1" className={classes.templateLabel}>
            Template:
          </Typography>
          <Select
            value={selectedTemplate}
            onChange={(e) => onTemplateChange(e.target.value)}
            variant="outlined"
            size="small"
            className={classes.select}
          >
            {templates.map((template) => (
              <MenuItem key={template.id} value={template.id}>
                {template.name}
              </MenuItem>
            ))}
          </Select>
        </div>
      </div>
    </Paper>
  );
};

export default TemplateSelector;
